import { TFunction } from 'i18next';

enum LockStateEnum {
	Locked = 'Locked',
	Unlocked = 'Unlocked',
	Unknown = 'Unknown',
}

export function getLockStateEnumLabel(lockState: LockStateEnum, t: TFunction): string {
	switch (lockState) {
		case LockStateEnum.Locked:
			return t('lockState.labels.locked', { ns: 'entities' });
		case LockStateEnum.Unlocked:
			return t('lockState.labels.unlocked', { ns: 'entities' });
		case LockStateEnum.Unknown:
			return t('general.unknown', { ns: 'entities' });
		default:
			return t('general.unknown', { ns: 'entities' });
	}
}

export default LockStateEnum;
